const { InnerBlocks, RichText } = wp.blockEditor;
import SvgCheckIcon from '../../images/SvgCheckIcon';

const Save = ({ attributes }) => {
  const { title, hasIcon, icon, image, variant, align, color, margin, iconPosition } =
    attributes;

  const justTitle = variant === 'just-title';
  const imageDescription = variant === 'image-description'
  const titleMargin = justTitle ? 'margin-none' : 'margin-extra-small';

  return (
    <div className={`TopicItem ${variant} ${margin}`}>
      <div
        className={`TopicItem__title ${titleMargin} ${iconPosition} ${color}`}
      >
        {hasIcon && (
          <span className={`TopicItem__title--icon`}>
            {icon.src ? (
              <img src={icon.src} alt={icon.alt} height={icon.height} />
            ) : (
              <SvgCheckIcon />
            )}
          </span>
        )}

        {!justTitle && !imageDescription ? (
          <RichText.Content
            tagName="h3"
            value={title}
            className={`Typography subtitle ${align}  margin-none`}
          />
        ) : !justTitle && imageDescription ? (
          <div className='topic-with-image'>
            <img src={image.src} alt={image.alt} />
            <InnerBlocks.Content />
          </div>) : (
          <InnerBlocks.Content />
        )}
      </div>

      {!justTitle && !imageDescription && <InnerBlocks.Content />}
    </div>
  );
};

export default Save;
